import { Box, Button, styled, Table, TableBody, TableCell, tableCellClasses, TableHead, TableRow, Typography, useMediaQuery } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import { authAtom, shopsAtom, sourcesAtom, servicessAtom, staffsAtom, tokenAtom } from '../../../../actions/index';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import WalletItem from '../components/WalletItem';

import { convertMoney, showConfirmationToast } from '../../../../utils/utils';
import { toast } from 'react-toastify';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const WalletTab = ({ username: lead_username }) => {
    const [auth] = useAtom(authAtom);
    const [shops] = useAtom(shopsAtom);
    const [sources] = useAtom(sourcesAtom);
    const [services] = useAtom(servicessAtom);
    const [staffs] = useAtom(staffsAtom);
    const [token] = useAtom(tokenAtom);
    const history = useHistory();

    const [wallets, setWallets] = useState([]);

    const isMobile = useMediaQuery('(max-width:600px)');

    const getWallets = useCallback(() => {
        if (token) {
            axios.post('/accounts/users/get_user_transactions/', {
                username: lead_username
            }, { headers: { Authorization: `Token ${token}` } })
                .then(res => {
                    if (res && res.data) {
                        setWallets(res.data);
                    }
                })
                .catch((error) => {
                    console.log({ error });
                });
        }
    }, [token, lead_username]);

    useEffect(() => {
        getWallets();
    }, [getWallets]);

    let totalAmount = 0;

    if (wallets && wallets.length > 0) {
        for (var i = 0; i < wallets.length; i++) {
            const transaction = wallets[i];
            totalAmount = totalAmount + ((transaction.transaction_type === 1) ? transaction.amount : -transaction.amount);
        }
    }

    const onDeleteItem = (item) => {
        if (token) {
            showConfirmationToast(`Có chắn chắn xóa giao dịch này?`, () => {
                axios.post('/accounts/users/delete_wallet_transaction/', {
                    transaction_id: item.id
                }, { headers: { Authorization: `Token ${token}` } })
                    .then(res => {
                        if (res && res.data) {
                            toast.success('Xóa giao dịch thành công!');
                            getWallets();
                        } else {
                            toast.error('Xóa giao dịch thất bại!');
                        }
                    })
                    .catch((error) => {
                        console.log({ error });
                        toast.error('Có lỗi xảy ra khi xóa giao dịch!');
                    });
            }, () => { }
            )
        }
    }

    return (
        <Box
            sx={{
                width: '100%'
            }}
        >
            <Typography
                sx={{
                    textAlign: 'center',
                    fontSize: isMobile ? '16px' : '20px',
                    fontWeight: 'bold',
                    marginBottom: '20px'
                }}
            >
                {`Số dư ví: ${convertMoney(totalAmount)}đ`}
            </Typography>
            <Table sx={{ width: '100%' }}>
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Mã GD</StyledTableCell>
                        <StyledTableCell>Số tiền</StyledTableCell>
                        <StyledTableCell>Thời gian</StyledTableCell>
                        <StyledTableCell sx={{ minWidth: '120px' }}>Ghi Chú</StyledTableCell>
                        <StyledTableCell>Xóa</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        wallets.map((item, index) => (
                            <WalletItem wallet={item} onDelete={() => onDeleteItem(item)} />
                        ))
                    }
                </TableBody>
            </Table>
        </Box>
    );
};

export default WalletTab;
